<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Jika password dirubah maka Anda akan <em>logout</em> secara
          otomatis dan harus melakukan <em>login</em> ulang kembali.</FormNote
        >

        <FormRow class="mb-4">
          <template #label>Name</template>
          <template #field>
            <input
              class="bg-gray-400 bg-opacity-25 form__input"
              readonly
              disabled
              type="text"
              :value="formData.name"
            />
          </template>
        </FormRow>
        <FormRow class="mb-4">
          <template #label>Username</template>
          <template #field>
            <input
              class="bg-gray-400 bg-opacity-25 form__input"
              readonly
              disabled
              type="text"
              :value="formData.username"
            />
          </template>
        </FormRow>
        <FormRow class="mb-4">
          <template #label>Role</template>
          <template #field>
            <input
              class="bg-gray-400 bg-opacity-25 form__input"
              readonly
              disabled
              type="text"
              :value="formData.role.name"
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Assets</template>
          <template #field>
            <multiselect
              :options="listAsset"
              :loading="listAssetLoading"
              :multiple="true"
              :close-on-select="false"
              track-by="id"
              label="name"
              placeholder="Search asset"
              v-model="formData.assets"
            >
              <template #noOptions>Enter asset name</template>
              <template #noResult>No results found</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.assets.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.assets.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #help
            >This user will only be allowed to access the selected
            assets.</template
          >
        </FormRow>

        <FormRow class="mb-4" :required="false">
          <template #label>Old Password</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.old_password.$error && formSubmitted,
              }"
              type="password"
              class="form__input"
              placeholder="*****"
              v-model="formData.old_password"
            />
            <div
              class="form-error"
              v-if="$v.formData.old_password.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.old_password.requiredIf"
                >This field is required if you want to change to a new
                password.</span
              >
            </div>
          </template>
        </FormRow>
        <FormRow class="mb-4">
          <template #label>New Password</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.new_password.$error && formSubmitted,
              }"
              type="password"
              class="form__input"
              placeholder="*****"
              v-model="formData.new_password"
            />
            <div
              class="form-error"
              v-if="$v.formData.new_password.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.new_password.minLength"
                >Password must be at least 5 characters.</span
              >
            </div>
          </template>
        </FormRow>
        <FormRow class="mb-4">
          <template #label>Re-enter New Password</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.new_password_confirmation.$error && formSubmitted,
              }"
              type="password"
              class="form__input"
              placeholder="*****"
              v-model="formData.new_password_confirmation"
            />
            <div
              class="form-error"
              v-if="
                $v.formData.new_password_confirmation.$error && formSubmitted
              "
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.new_password_confirmation.required"
                >This field is required if you want to change to a new
                password.</span
              >
              <span
                class="form-error__text"
                v-if="!$v.formData.new_password_confirmation.sameAsNewPassword"
                >Please enter the same password.</span
              >
            </div>
          </template>
        </FormRow>
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import {
  required,
  sameAs,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import { submitFormMixin } from "@/mixins/submitFormMixin";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  mixins: [submitFormMixin],
  validations: {
    formData: {
      assets: {
        required,
      },
      old_password: {
        required: requiredIf(function () {
          return this.formData.new_password;
        }),
      },
      new_password: {
        minLength: minLength(5),
      },
      new_password_confirmation: {
        required: requiredIf(function () {
          return this.formData.new_password;
        }),
        minLength: minLength(5),
        sameAsNewPassword: sameAs("new_password"),
      },
    },
  },
  computed: {
    submitUrl() {
      return "/profile";
    },
  },
  created() {
    this.formCreate = false;
    this.getProfile();
  },
  data() {
    return {
      listAsset: [],
      listAssetLoading: true,

      formData: {
        assets: [],
      },
    };
  },
  methods: {
    getProfile() {
      this.formReady = false;

      this.$http
        .get(process.env.VUE_APP_API_URL + "/profile")
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };
            this.listAsset = data.assets;
            this.listAssetLoading = false;

            this.formData.assets = [];

            data.assets.forEach((item, index) => {
              if (data.assets[index].active == 1) {
                this.formData.assets.push(data.assets[index]);
              }
            });

            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        const method = this.formCreate ? "post" : "patch";
        const url = process.env.VUE_APP_API_URL + this.submitUrl;

        this.$http({
          method: method,
          url: url,
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$swal({
                position: "bottom-end",
                showConfirmButton: false,
                toast: true,
                timer: 5000,
                timerProgressBar: true,
                title: res.data.message,
                icon: "success",
              });

              this.formData.new_password = "";
              this.formData.new_password_confirmation = "";
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  },
};
</script>
